// ===============================================
// reglasServicios.js
// Reglas técnicas de comportamiento
// ===============================================

function regla({
  duracionMin = 60,
  bufferMin = 0,
  bloqueaPrevio = 0,
  bloqueaPosterior = 0,
  permiteTopar = false,
  capacidadMax = 1,
}) {
  return {
    duracionMin,
    bufferMin,
    bloqueaPrevio,
    bloqueaPosterior,
    permiteTopar,
    capacidadMax,
  };
}

// ===============================================
// REGLAS TÉCNICAS
// ===============================================

export const REGLAS_SERVICIOS = {

  // fallback seguridad
  default: regla({
    duracionMin:60,

    bloqueaPrevio:30,

    //bloqueaPosterior:0,

    permiteTopar:false,

    capacidadMax:1,
  }),

  // modalidad PRIVADA

  privada: regla({

    duracionMin:60,

    bloqueaPrevio:30,

    //bloqueaPosterior:0,

    permiteTopar:false,

    capacidadMax:1,

  }),

  // modalidad GRUPAL

  grupal: regla({

    duracionMin:60,

    bloqueaPrevio:0,

    //bloqueaPosterior:0,

    permiteTopar:true,

    capacidadMax:2,

  }),

};

// =============================================================
// REGLA FINAL
// =============================================================

export function getReglaServicio(
  categoria,
  variante,
  modalidad,
  esPrimeraSesion
) {

  const modalidadNorm =
    (modalidad || "")
    .toLowerCase()
    .trim();

  // primera sesión SIEMPRE privada

  if (esPrimeraSesion) {

    return REGLAS_SERVICIOS.privada;

  }

  // modalidad explícita elegida

  if (modalidadNorm === "grupal") {

    return REGLAS_SERVICIOS.grupal;

  }

  if (modalidadNorm === "grupal") {

    return REGLAS_SERVICIOS.grupal;

  }

  // cualquier otra cosa:

  return REGLAS_SERVICIOS.privada;

}